module.exports = __webpack_public_path__ + "static/media/eighteenth_friendship_way2.9eb1d980.png";